import Component from '../abstracts/Component';
import Cookies from 'js-cookie';

export default class FidelityPopupComponent extends Component {

  get COMPONENTNAME() {
      return 'FidelityPopupComponent';
  }

  get COOKIE_NAME() {
    return 'fidelity_popup_hide';
  }

  // MILLISECONDS //
  get TIMER() {
    return {
      start: 8000,
    }
  }

  get SELECTORS() {
    return {
      closeIcon: '[data-fidality-popup] .icon-close',
      ctaBtn: '[data-fidality-popup] .cta',
      fidelityPopup: '[data-js-component="FidelityPopupComponent"]',
    };
  }

  constructor(elem) {
    super(elem);
  }

  readDOM() {
    return {
      closeBtn: this.$component.querySelector(this.SELECTORS.closeIcon),
      ctaBtn: this.$component.querySelector(this.SELECTORS.ctaBtn),
      starTimerID: '',
      endTimerID: ''
    }
  }

  render() {
    this.log("Rendering...");
    
    //cookie does not exists yet
    if(!this.getCookie()) {
      this.dom = this.readDOM();
      this.bindEvents();
      this.showTimer();
    }
  }

  // EVENT LISTENERS //
  bindEvents() {


    // CTA click action
    const ctaBtn = this.dom.ctaBtn;
    if (ctaBtn)
    {
      ctaBtn.addEventListener('click', (event) =>
      {
        this.showPopup(false);
      });
    }
    // Close action
    const closeIcon = this.dom.closeBtn;
    if (closeIcon)
    {
      closeIcon.addEventListener('click', (event) =>
      {
        this.showPopup(false);
      });
    }

  }

  // FUNCTIONS //
  showTimer() {
    this.dom.starTimerID =
      setTimeout( () => {
        this.showPopup(true);
        this.setCookie();
      }, this.TIMER.start);
  }


  // UTILS //
  showPopup(isVisible) {
    if (isVisible){
      this.$component.classList.remove('hidden')
    }
    else{
      this.$component.classList.add('hidden');
      this.setCookie();
      this.emit(this.$customEvents.FIDELITY_POPUP.hide);
    }
  }

  setCookie() {
     Cookies.set(this.COOKIE_NAME, 'true');
  }

  getCookie() {
    return Cookies.get(this.COOKIE_NAME);
  }

  isShown(){
    const fidelityPopup = document.querySelector(this.SELECTORS.fidelityPopup);
    return fidelityPopup ? true : false
  }
}
